module.exports = __webpack_public_path__ + "static/media/eedc.1776b403.svg";